import { useEffect, useState } from "react";
import lottie from "lottie-web";
import axios from "axios";
import Loadinggif from "../Arthmate/Modules/BasicInfo/threedots.gif";
import { env } from "../../environment/environment";
import { useNavigate } from "react-router-dom";
import routes from "../../../layout/Routes";

export default function BottomPopOverModal({
    searchAnimation,
    showPopOver,
    setShowPopOver,
    checkAndNavigate = () => { },
}) {
    const [stage, setStage] = useState("loading");
    const [otpKfin, setOtpKfin] = useState("123456");
    const [otpCams, setOtpCams] = useState("12345");
    const [loanId, setLoanId] = useState("");
    const [error, setError] = useState("");
    const [timer, setTimer] = useState(59);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    let navigate = useNavigate()
    // Load animation
    useEffect(() => {
        if (searchAnimation) {
            lottie.loadAnimation({
                container: document.querySelector("#searchAnimation"),
                animationData: searchAnimation,
                renderer: "canvas",
            });
        }
    }, []);

    useEffect(() => {
        if (showPopOver) {
            const userId = localStorage.getItem("userId");
            if (userId) {
                axios
                    .get(env.api_Url + `userDetails/getLoanDetailsByUserId?userId=${userId}`)
                    .then((response) => {
                        const fetchedLoanId = response.data?.data?.loanId;
                        setLoanId(fetchedLoanId);
                    })
                    .catch((err) => {
                        setError("Unable to fetch loan details.");
                        setShowPopOver(false);
                    });
            }
        }
    }, [showPopOver]);

    useEffect(() => {
        if (showPopOver && loanId) {
            setStage("loading");
            const timer = setTimeout(async () => {
                try {
                    const res = await fetch(`${env.api_Url}fiftyFin/generateOtp?loanId=${loanId}`);
                    const data = await res.json();
                    if (data.message === "success") {
                        setStage("otp");
                    } else {
                        setError("Failed to send OTP. Please try again.");
                        setShowPopOver(false);
                    }
                } catch {
                    setError("Something went wrong.");
                    setShowPopOver(false);
                }
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [loanId]);

    useEffect(() => {
        if (!showPopOver) {
            setStage("loading");
            setOtpKfin("");
            setOtpCams("");
            setError("");
        }
    }, [showPopOver]);

    useEffect(() => {
        if (stage === "otp") {
            setTimer(59);
            setIsResendDisabled(true);
            const interval = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [stage]);

    // Resend OTP
    const handleResend = async () => {
        if (isResendDisabled) return;
        try {
            const res = await fetch(`${env.api_Url}/fiftyFin/generateOtp?loanId=${loanId}`);
            const data = await res.json();
            if (data.message !== "success") setError("Resending failed.");
            else {
                setError("");
                setTimer(59);
                setIsResendDisabled(true);
                const interval = setInterval(() => {
                    setTimer((prev) => {
                        if (prev <= 1) {
                            clearInterval(interval);
                            setIsResendDisabled(false);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            }
        } catch {
            setError("Something went wrong.");
        }
    };

    const handleSubmitOtp = async () => {
        if (otpKfin.length !== 6 || otpCams.length !== 5) {
            setError("Please enter valid OTPs.");
            return;
        }

        setStage("verify");

        try {
            const res = await fetch(
                `${env.api_Url}/fiftyFin/validateOtp?loanId=${loanId}&camsOTP=${otpCams}&karvyOTP=${otpKfin}`
            );
            const data = await res.json();
            // console.log(data, 'EligibleEligibleEligible')
            if (data.message === "success") {
                checkAndNavigate("eligible");
                setTimeout(() => {
                    // window.location.href = "/patient/lamfeligibilitychecker";
                    navigate(routes.LMAF_ELIGIBLE)
                }, 0);
            } else {
                checkAndNavigate("ineligible");
                setTimeout(() => {
                    // window.location.href = "/patient/lamfIneligible";
                    navigate(routes.LMAF_NOT_ELIGIBLE)

                }, 0);
            }

            setShowPopOver(false);
        } catch {
            setError("OTP verification failed.");
            setStage("otp");
        }
    };

    if (!showPopOver) return null;

    return (
        <div
            className={"bottomPopOverModal " + (showPopOver ? "open" : "")}
            onClick={() => setShowPopOver(false)}
            style={{
                height: "100%",
                width: "100%",
                background: "rgba(0,0,0,0.2)",
                position: "fixed",
                top: "0",
                left: "0",
                zIndex: 5,
                display: "flex",
                alignItems: "center",
                padding: "0",
            }}
        >
            <div
                className="popUpCard-custom"
                style={{
                    width: "100%",
                    background: "white",
                    boxShadow: "0px 0px 10px #ccc",
                    borderRadius: "8px 8px 0px 0px",
                    padding: "10px",
                    paddingBottom: "48px",
                    position: "absolute",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {stage === "loading" && (
                    <div style={{ textAlign: "center" }}>
                        <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                            <b>Loan on mutual funds</b>
                        </div>
                        <img src={Loadinggif} style={{ width: "100px" }} alt="loading" />
                        <p style={{ marginTop: "-10px" }}>Sending OTP on your number...</p>
                    </div>
                )}

                {stage === "otp" && (
                    <>
                        <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                            <b>Loan on mutual funds</b>
                        </div>

                        <p>Enter the 6 digit OTP sent by <b>Kfintech</b>:</p>
                        <input
                            type="text"
                            maxLength={6}
                            value={otpKfin}
                            placeholder="- - - - - -"
                            onChange={(e) => setOtpKfin(e.target.value.replace(/\D/g, ""))}
                            style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
                        />

                        <p>Enter the 5 digit OTP sent by <b>CAMS</b>:</p>
                        <input
                            type="text"
                            maxLength={5}
                            value={otpCams}
                            placeholder="- - - - -"
                            onChange={(e) => setOtpCams(e.target.value.replace(/\D/g, ""))}
                            style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
                        />

                        {error && <p style={{ color: "red", fontSize: "13px" }}>{error}</p>}

                        <div
                            onClick={!isResendDisabled ? handleResend : undefined}
                            style={{
                                marginTop: "10px",
                                textAlign: "end",
                                color: isResendDisabled ? "gray" : "#514C9F",
                                cursor: isResendDisabled ? "not-allowed" : "pointer",
                            }}
                        >
                            {isResendDisabled
                                ? `Resend OTP in 0:${timer < 10 ? `0${timer}` : timer}`
                                : "Resend OTP"}
                        </div>

                        <button
                            className="submit"
                            onClick={handleSubmitOtp}
                            style={{ width: "100%", marginTop: "10px", padding: "10px" }}
                        >
                            Submit OTP
                        </button>
                    </>
                )}

                {stage === "verify" && (
                    <div style={{ textAlign: "center" }}>
                        <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                            <b>Loan on mutual funds</b>
                        </div>
                        <img src={Loadinggif} style={{ width: "100px" }} alt="loading" />
                        <p style={{ marginTop: "-10px" }}>Checking your eligibility for loan on mutual funds...</p>
                    </div>
                )}
            </div>
        </div>
    );
}
